import React, { useEffect } from 'react'
import Sidebar from '../components/Sidebar'
import Header from '../components/Header'
import UsersTable from '../components/Users/UsersTable'

const UsersPage = () => {

  useEffect(() => {
    document.title = 'Pengguna - Admin Hi Nano';
  });

  return (
    <div className="flex min-h-screen bg-slate-100">
            <Sidebar />
            <div className="flex-1 p-10 ml-28">
                <Header title="Pengguna" />
                <UsersTable />
            </div>
        </div>
  )
}

export default UsersPage